import { call, put, takeLatest } from "redux-saga/effects";
import {
    GET_DUTYYPES,
    ADD_DUTYTYPES,    
    UPDATE_DUTYTYPES,
    DELETE_DUTYTYPES,
    GET_DUTYYPES_SUCCESS,
    ADD_DUTYTYPES_SUCCESS,
    UPDATE_DUTYTYPES_SUCCESS,
    DELETE_DUTYTYPES_SUCCESS,
  
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getDutyApi()  {
  // api for get employeetype
 const response = api.dbduty().GetDutyTypes();
  return response;
}

function addDutyApi(formData) {
  // api for add  employeetype.
  api.dbLeaveTypes().AddEditDutyTypes(formData);
}

function updateDutyApi(formData) {
  // api for update  employeetype.
  api.dbLeaveTypes().AddEditDutyTypes(formData);
}
function deleteDutyApi(delId) {
  // api for delete  employeetype.
  const response = api.dbLeaveTypes().DeleteDutyTypes(delId);
  return response;
}

export function* handleGetDuty() {
  try {
    const response = yield call(getDutyApi);
    yield put({ type: GET_DUTYYPES_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}

export function* handleAddDuty({ payload }) {
  try {
    yield call(addDutyApi, payload);
    yield put({ type: ADD_DUTYTYPES_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

export function* handleUpdateDuty({ payload }) {
  try {
    let formData = payload;
    yield call(updateDutyApi, formData);
    yield put({ type: UPDATE_DUTYTYPES_SUCCESS, payload: formData });
  } catch (error) {
     
  }
}
export function* handleDeleteDuty({ payload }) {
  try {
    yield call(deleteDutyApi, payload);
    yield put({ type: DELETE_DUTYTYPES_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

// watach function.
export function* dutytypeWatchFun() {
  yield takeLatest(GET_DUTYYPES, handleGetDuty);
  yield takeLatest(ADD_DUTYTYPES, handleAddDuty);
  yield takeLatest(UPDATE_DUTYTYPES, handleUpdateDuty);
  yield takeLatest(DELETE_DUTYTYPES, handleDeleteDuty);

}